function addScaleGradient(){
	var scaleColors = [{color: '#FF797F', offset: '0%'}, {color: '#E5B143', offset: '50%'}, {color: '#7BEB9E', offset: '100%'}];
	mainChart.selectAll('defs')
			.append('linearGradient')
			.attr('id', 'scaleGradient')
			.attr("x1","0%")
            .attr("x2","100%")
            .attr("y1","0%")
            .attr("y2","0%");
    var stops = d3.select('#scaleGradient').selectAll('stop').data(scaleColors);
    stops.enter().append('stop');
    stops.attr('offset',function(d) {
                    return d.offset;
                })
                .attr('stop-color',function(d) {
                    return d.color;
                });
}

function scalePositions(){
	var ticks = mainChart.xAxis().ticks()[0];
	var svg = d3.select(mainChart.svg()[0][0]);
	var axisDimensions = svg.select('.axis.x').node().getBBox();
	var maxScaleWidth = (axisDimensions['width'] / ticks);
	maxScaleWidth = (maxScaleWidth > 130 ? 130 : maxScaleWidth);
	var positions = {};
	svg.select('.axis.x').selectAll('.tick').each(function(){
		var self = d3.select(this);
		var x = parseFloat(self.attr('transform').match(/[\w\.\-]+/g)[1]) - (maxScaleWidth / 2) + 30;
		positions[monthFormat(this.__data__)] = {x: x, width: maxScaleWidth};
	});
	return positions;
}

function createScales(placement){
	var svg = d3.select(mainChart.svg()[0][0]);
	svg.select('g.scales').remove();
	svg.select('#scaleGradient').remove();
	svg.attr('height', '275');
	var height = svg.select('.axis.x').node().getBBox()['height'];
	var monthCount = monthDiff($('#from').datepicker('getDate'), $('#to').datepicker('getDate'));
	mainChart.select('svg')
		.append('g')
		.attr('transform', 'translate(0,'+(220+height)+')')
		.attr('class', 'scales');
	addScaleGradient();
	var positions = scalePositions();
	
	var i = 0;
	for(var p in positions){
		var scale = d3.scale.linear().domain([1,5]).range([0, positions[p].width]);
		var scaleAxis = d3.svg.axis()
							.orient('bottom')
							.scale(scale)
							.tickSize(6)
							.ticks(5)
							.tickFormat(function(d){
								switch(d){
									case 1:
										return (monthCount > 3 ? '' : 'Poor');
										break;
									case 2:
										return '';
										break;
									case 3:
										return 'Fair';
										break;
									case 4:
										return '';
										break;
									case 5:
										return (monthCount > 3 ? '' : 'Good');
										break;
									default:
										return;
								}
							});
		var g = mainChart.select('g.scales').append('g').attr('class', 'scale_'+i);
		var rect = g
		.append('rect')
		.attr('fill', 'url(#scaleGradient)')
		.attr('x', positions[p].x)
		.attr('y', 5)
		.attr('width', positions[p].width)
		.attr('height', 20);

		g
		.append('g')
		.attr('class', 'axis')
		.attr('transform', 'translate('+(positions[p].x)+',25)')
		.call(scaleAxis);

		if(p in placement){
			var xAVG = (((placement[p].avg - 1) * positions[p].width) / 4) + positions[p].x;
			g
			.append('circle')
			.attr('r', 5)
			.attr('cy', '15')
			.attr('cx', xAVG);
		}

		i++;
	}
	mainChart.select('g.scales').selectAll('g.tick').select('line').attr('y2', '-20');
}